import cn from 'classnames';

import Card from './Card';

interface ModalProps {
  handleClose?: () => void;
  body: React.ReactElement;
  title?: string;
  footer?: React.ReactElement;
  notes?: string;
  className?: string;
}

export default function Modal({ title, footer, notes, body, handleClose, className }: ModalProps) {
  return (
    <div
      role="button"
      tabIndex={0}
      className="fixed inset-0 z-10 overflow-y-auto"
      onClick={() => handleClose && handleClose()}
      onKeyDown={() => handleClose && handleClose()}
    >
      <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 bg-black bg-opacity-50" />

        {/* This element is to trick the browser into centering the modal contents. */}
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>

        <Card
          className={cn(
            className,
            'inline-block p-8 md:p-12 shadow-xl overflow-hidden text-left align-bottom rounded-lg transform transition-all sm:my-8 sm:align-middle sm:p-6',
          )}
        >
          {title && (
            <div>
              <h2 className="text-2xl font-bold sm:text-3xl sm:truncate">{title}</h2>
            </div>
          )}
          {notes && <div className="mt-4 text-gray-500 italic mb-6">{notes}</div>}

          <div className="mt-8">{body}</div>

          {footer && <div className="w-full pt-6 mt-8 border-t border-gray-300">{footer}</div>}
        </Card>
      </div>
    </div>
  );
}
